/**
 * Template Tag JS
 *
 * JS for functions in template-tags.php.
 */

import './mobile-menu';
import './modal';
import './navigation-primary';
import './off-canvas';
import './table';
import './video';
import './accordion';
import './carousel';
import './photoswipe';
import './scroll-spy';
import './kd-dropdown';
import './filter-navigation';
import './layout-toggle';
import './scroll-classes';
import './back-to-top-button';
